import { css } from '@emotion/core'
import { color, mediaDn, padding, spacer, typography } from 'stylist'

export const container = ({ theme }) => css`
  margin-bottom: ${spacer(4, { theme })};
  max-width: 32%;
  flex-basis: 32%;

  ${mediaDn('lg')} {
    flex-basis: 48%;
    max-width: 48%;
  }

  ${mediaDn('sm')} {
    flex-basis: 100%;
    max-width: none;
  }

  @supports (display: grid) {
    & {
      margin-bottom: 0;
      max-width: none;
    }
  }
`

export const link = ({ theme }) => css`
  color: ${color('ink', { theme })};
  background: ${color('white', { theme })};
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 6rem;

  ${typography('body4Medium', { theme })};
  ${padding('xs', { theme })};
`



// WEBPACK FOOTER //
// ./src/routes/home/components/platformLinkStyles.js